// @flow

// types
import type { GenericAction } from '../Types/ReduxTypes'

const subProducts = {
  tpl: 'POV',
  cic: 'HAV',
  default: 'CES',
}

const eventDefinitionsMap = (rAction: GenericAction) => {
  switch (rAction.type) {
    case 'ADD_GTM_EVENT':
      return (action: GenericAction, prevState: Object) => {
        return {
          hitType: 'event',
          event: 'gaEvent',
          eventCategory: `${subProducts[prevState.appData.product.subProductName]} Event`,
          eventAction: action.action,
          eventLabel: action.label,
          eventValue: action.value ? action.value : 'unknown value',
        }
      }
    case 'SET_GTM_PAGE_VIEW':
      return (action: GenericAction) => {
        return {
          hitType: 'pageview',
          event: 'pageview',
          page: window.location.pathname || action.page,
          title: action.title ? `${action.title}` : 'unknown title',
        }
      }
    case 'ON_SET_LAST_VALID_STEP':
      return (action: GenericAction, prevState: Object) => {
        const events = []
        switch (prevState.appData.navigation.lastValidStep.index) {
          case 0:
            const product = prevState.appData.product.productName
            const subProduct = prevState.appData.product.subProductName
            if (action.key === 'quotes' && product !== 'travel') {
              if (
                prevState.userData.data &&
                prevState.userData.data.policyHolder &&
                prevState.userData.data.policyHolder.phoneNumber
              ) {
                events.push({
                  hitType: 'event',
                  event: 'gaEvent',
                  eventAction: 'Fill',
                  eventCategory: `${subProducts[subProduct]} Event`,
                  eventLabel: 'Telefon',
                })
              }
              if (subProduct === 'tpl' && prevState.userData.data.cicEnabled) {
                events.push({
                  hitType: 'event',
                  event: 'gaEvent',
                  eventAction: 'Send',
                  eventCategory: `${subProducts.tpl} Event`,
                  eventLabel: 'HAV',
                })
              }
            }
            break
        }
        return events
      }
    case 'SEND_LEAVE_SCREEN_LOG':
      return () => ({
        hitType: 'event',
        event: 'gaEvent',
        eventCategory: 'Callback Form',
        eventAction: 'Show',
        eventLabel: 'Leaving',
        eventValue: 'unknown value',
      })
  }
}

export default eventDefinitionsMap
